export default {"src":"/_next/static/media/search.3f5e9892.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};